import NextImage, { ImageLoaderProps } from 'next/image';

import arrowBlack from './assets/arrow-black.svg';
import { AppDownloadModal } from '../AppDownloadModal/AppDownloadModal';
import { AppStoreButtons } from '../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
import { FishCatchesIcon } from '../Icons/FishCatchesIcon';
import { NextImageWrapper } from '../NextImage/NextImageWrapper';
import { QRCode } from '../QRCode/QRCode';
import {
  GetFishingWater_fishingWater_topAnglers_anglers_edges_node_displayIcon,
  GetPlaceTopAnglers_entry_topAnglers_anglers_edges_node_displayIcon,
} from '../../interfaces/graphql';
import { getImgProxyLoader } from '../../helpers/imageLoaders/imgProxy';

interface IProps {
  appDownloadSourceId?: string;
  isAppDownloadModalOpen: boolean;
  setIsAppDownloadModalOpen: (isOpen: boolean) => void;
  displayIcon:
    | GetFishingWater_fishingWater_topAnglers_anglers_edges_node_displayIcon
    | GetPlaceTopAnglers_entry_topAnglers_anglers_edges_node_displayIcon;
  anglerName: string;
}

export const OtherAnglersDownloadModal = ({
  appDownloadSourceId,
  isAppDownloadModalOpen,
  setIsAppDownloadModalOpen,
  displayIcon,
  anglerName,
}: IProps) => {
  const imgProxyLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getImgProxyLoader(src, width, displayIcon.width, displayIcon.height, { quality });

  return (
    <AppDownloadModal
      appDownloadSource={'OtherAnglers'}
      appDownloadSourceId={appDownloadSourceId}
      isModalOpen={isAppDownloadModalOpen}
      onCloseModal={() => setIsAppDownloadModalOpen(false)}
      closeButtonVariant="textNone"
      width="440px"
    >
      <div className="flex flex-col gap-6 px-6 pb-6 pt-10">
        <div className="flex items-center justify-center">
          <div className="relative size-full w-28 sm:w-40">
            <NextImageWrapper
              wrapperClassName="size-full"
              customPlaceholderIcon={<FishCatchesIcon size={100} title="fish catches icon" />}
              imageClassName="aspect-[1/1] size-full object-cover rounded-full"
              alt="recently logged catch"
              width={displayIcon.width}
              height={displayIcon.height}
              src={displayIcon.url}
              loader={imgProxyLoader}
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <Heading variant="sm" className="m-0 text-center font-semibold">
            {`Discover more from ${anglerName} and other local anglers`}
          </Heading>
          <Text variant="sm" className="m-0 text-center">
            Browse profiles, explore catches, and see who’s fishing nearby—all in the Fishbrain app.
          </Text>
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:justify-end sm:p-4">
          <div className="flex items-center justify-center md:hidden">
            <AppStoreButtons
              orientation="vertical"
              context="downloadModal"
              source={'OtherAnglers'}
              sourceId={appDownloadSourceId}
            />
          </div>
          <div className="relative hidden pb-2 md:flex">
            <Text className={`m-0 -rotate-12 whitespace-pre-line text-trench`} variant="sm">
              {`Scan the QR code 
                            to download the app!`}
            </Text>
            <NextImage
              alt="Arrow pointing to QR code"
              src={arrowBlack}
              className="absolute bottom-0 right-0 translate-y-full"
              unoptimized
            />
          </div>

          <QRCode
            size={140}
            imageSize={35}
            className="hidden sm:flex sm:justify-end sm:p-4"
            source={'FishingReportCard'}
            showOnMobileDevice
          />
        </div>
      </div>
    </AppDownloadModal>
  );
};
